export default __webpack_public_path__ + "static/media/rtp-global_6.2719d372.png";